import { WatchAccountService } from '../../../services/watch-account.service';
import { AccountService } from '../../../services/account.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

@Component({
  selector: 'modal-create-funnel',
  template: require('./modal-create-funnel.component.pug'),
  styles: [require('./modal-create-funnel.component.css').toString()],
})
export class ModalCreateFunnelComponent implements OnInit {
  form: FormGroup;
  sharing: number = 0;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    fb: FormBuilder,
    private account_service: AccountService,
    private watch_account: WatchAccountService,
    private router: Router,
  ) {
    this.form = fb.group({
      name: ['', Validators.required],
    });
  }

  // -------------------------------------------------------------------
  ngOnInit() {}

  // -------------------------------------------------------------------
  setSharing(sharing: number) {
    this.sharing = sharing;
  }

  // -------------------------------------------------------------------
  getSharing() {
    return this.sharing;
  }

  // -------------------------------------------------------------------
  getName() {
    return this.form.get('name').value;
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let account_id = this.watch_account.accountId().getValue();

    this.account_service.createFunnel(
      account_id,
      this.getName(),
      this.sharing,
      res => {
        this.router.navigate([
          '/account/' +
            account_id +
            '/funnels/' +
            res.funnelId.toString() +
            '/steps',
        ]);
        this.bsModalRef.hide();
        //onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
